<app-loader></app-loader>

<div class="main-container" role="main" onbeforeunload="handleClose()">

  <!-- <button mat-mini-fab color="" [disabled]="!showMyContainer" (click)="speechText('Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Amet porttitor eget dolor morbi non arcu risus quis. Diam vel quam elementum pulvinar etiam non. Fusce id velit ut tortor pretium viverra. Augue interdum velit euismod in pellentesque massa placerat duis. Malesuada pellentesque elit eget gravida cum sociis natoque penatibus. Aliquam purus sit amet luctus venenatis lectus magna fringilla urna. Orci dapibus ultrices in iaculis nunc sed augue lacus viverra. Mi quis hendrerit dolor magna eget est lorem ipsum dolor. Dui id ornare arcu odio ut. Massa vitae tortor condimentum lacinia. Purus non enim praesent elementum facilisis leo vel fringilla est. Nam at lectus urna duis convallis convallis tellus id.')" matTooltipPosition="above"
  class="btn-size btn-primary" aria-label="Play Audio button">
  <mat-icon class="icon-size">play_arrow</mat-icon>
</button> -->


  <app-header *ngIf="userHeader == 1 && contentVisible"></app-header>

  <mat-sidenav-container class="example-container" autosize>
    <div class="example-sidenav-content">
      <div class="app-content-wrapper">
        <router-outlet></router-outlet>
      </div>

      <footer *ngIf="userHeader == 1 && contentVisible">
        <div class="footer-copyrights">
          © {{fullyear}} {{'footer.text' | translate}}
        </div>
      </footer>
    </div>

  </mat-sidenav-container>


  <!-- <app-userheader *ngIf="userHeader == 1"></app-userheader> -->


</div>
